// Clean scripture text pasted from a licensed Bible app or website.
export function cleanPastedScripture(raw) {
  let text = (raw || "").replace(/\r/g, "");
  text = text.replace(/\[[a-z0-9]{1,3}\]/gi, ""); // footnote markers
  text = text.replace(/[\u00B9\u00B2\u00B3\u2070-\u209F]/g, ""); // superscript verse numbers
  text = text
    .split("\n")
    .map((line) => line.replace(/^\s*\d+[\.:)]?\s+/, "").trim()) // leading verse numbers
    .join("\n");
  text = text.replace(/([^\n])\n(?!\n)/g, "$1 "); // unwrap hard-wrapped lines
  return text.replace(/[ \t]{2,}/g, " ").replace(/\n{3,}/g, "\n\n").trim();
}

const SUPERSCRIPTS = { 0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵", 6: "⁶", 7: "⁷", 8: "⁸", 9: "⁹" };

export const toSuperscript = (n) =>
  String(n)
    .split("")
    .map((d) => SUPERSCRIPTS[d] || d)
    .join("");

// Build the slide text from looked-up verses: optional raised verse numbers, reference in brackets at the end.
export function buildScriptureText(verses, { withNumbers = true, reference = "" } = {}) {
  const body = (verses || [])
    .map((v) => (withNumbers ? `${toSuperscript(v.verse)} ${v.text}` : v.text))
    .join(" ")
    .replace(/\s{2,}/g, " ")
    .trim();
  const ref = (reference || "").trim();
  return ref ? `${body} (${ref})` : body;
}

export function scriptureTitle(reference, version) {
  const ref = (reference || "").trim();
  const ver = (version || "").trim();
  if (!ref) return ver || "Scripture";
  return ver ? `${ref} (${ver})` : ref;
}
